import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

import { podNameTypography, podNameVars } from '../styles-shared';

export const Name = styled.h1`
    &&& {
        ${styledReset.typography};
        ${podNameVars};
        ${podNameTypography};
    }
`;
